import PropTypes from "prop-types";

/*
 * decaffeinate suggestions:
 * DS102: Remove unnecessary code created because of implicit returns
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */
import React from "react";
import { actions } from "../../utils/overlay-store";
import Utils from "../../utils/basic-utils";
import OutsideClick from "../elements/outside-click";
import GlobalKeypress from "../elements/global-keypress";

export default class ModalWrapper extends React.Component {
  static displayName = "ModalWrapper";

  static propTypes = {
    render: PropTypes.func.isRequired,
    isOpen: PropTypes.bool,
    onClose: PropTypes.func,
    width: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    className: PropTypes.string,
    closeOnEscape: PropTypes.bool,
    closeOnOutsideClick: PropTypes.bool,
  };

  static defaultProps = {
    closeOnEscape: true,
    closeOnOutsideClick: true,
  };

  componentDidMount() {
    if (this.props.isOpen) {
      return this.handleLaunchModal();
    }
  }

  componentDidUpdate(prevProps) {
    if (!prevProps.isOpen && this.props.isOpen) {
      return this.handleLaunchModal();
    } else if (prevProps.isOpen && !this.props.isOpen) {
      return actions.removeModal();
    }
  }

  componentWillUnmount() {
    return actions.removeModal();
  }

  handleLaunchModal = () => {
    const dialog = React.cloneElement(this.renderModal());
    actions.launchModal(dialog);
    if (typeof this.props.onClick === "function") {
      this.props.onClick();
    }

    if (document.body.className) {
      return (document.body.className = `${document.body.className} et--modal-deprecated--is-open`);
    } else {
      return (document.body.className = "et--modal-deprecated--is-open");
    }
  };

  handleRemove = () => {
    document.body.className = Utils.removeClassname(document.body.className, "et--modal-deprecated--is-open");
    if (typeof this.props.onClose === "function") {
      this.props.onClose();
    }
    return actions.removeModal();
  };

  handleDelayedRemove = () => {
    return setTimeout(() => this.handleRemove(), 300);
  };

  handleOutsideClick = () => {
    if (this.props.closeOnOutsideClick) {
      return this.handleDelayedRemove();
    }
  };

  handleEscape = (e) => {
    if (this.props.closeOnEscape) {
      return this.handleDelayedRemove();
    }
  };

  renderModal = () => {
    const close = this.handleRemove;

    return (
      <div className={this.props.className}>
        <GlobalKeypress onEscape={this.handleEscape} />
        <OutsideClick
          className="et--modal-deprecated--overlay"
          closeOnElementClick
          onOutsideClick={this.handleOutsideClick}
        >
          <div className="et--modal-deprecated--dialog" style={{ width: this.props.width }}>
            {this.props.render({ close })}
          </div>
        </OutsideClick>
      </div>
    );
  };

  render() {
    return null;
  }
}
